'use es6';

import enviro from 'enviro';
import { createTreatmentsResolver } from './core/resolvers';
import { createDebugLogger, createExposureLogger } from './core/loggers';
import { getAsyncStore } from './core/store';
import { validateWithDefaults } from './core/validators';
import { DEBUG_MESSAGES } from './messages';
export function createClient(params = {}) {
  const validators = validateWithDefaults(params.onError, 'createClient'); // This method validates the inputs given to laboratory-lib and calls the onError
  // to report the error to Sentry or custom logic defined by the user
  // it will also mutate the values from the input to default ones
  // to prevent the application from being broken, as it attempts it best to recover

  const settings = Object.assign({}, params, {}, validators.validateStore(params.store), {}, validators.validateSearch(params.search), {}, validators.validateTimeout(params.timeout), {}, validators.validateCeid(params.ceid), {}, validators.validateCacheOnly(params.useCacheOnly), {}, validators.validateApiDomain(params.apiDomain), {}, validators.validateQuickFetchLabel(params.quickFetchLabel), {}, validators.validateExperimentsSchema(params.experiments, params.identifiers)); // @deprecated the treatments schema is deprecated and we put it in a different section
  // to highlight that it should be removed in the future
  // it also relies on the parsed experiments schema to verify if both are present
  // as only either experiments or treatments should be used

  const {
    treatments
  } = validators.validateTreatmentsSchema(settings.treatments, settings.experiments); // Thse are parameters that define the structure of the Experiments

  const {
    experiments,
    identifiers
  } = settings; // These are params that define behavioural aspects of the library

  const {
    store,
    timeout,
    onError,
    quickFetchLabel,
    apiDomain
  } = settings; // These are params that define overrides and extra functionalities

  const {
    ceid,
    search,
    useCacheOnly
  } = settings;
  const debug = // Check for enviro debug mode or if it's a local deployment
  enviro.debug('laboratory-lib') || enviro.debug('') || !enviro.deployed();
  const {
    logDebug
  } = createDebugLogger({
    debug
  }); // Validates quick-fetch parameter and creates a promise with a dynamic import of the resulting validation
  // This allows treeshaking and quick-fetch to be loaded actually only when needed.

  const {
    quickFetch
  } = validators.validateQuickFetch(settings.quickFetch, settings.quickFetchLabel); // Validates http parameter and creates a promise with a dynamic import of the resulting validation
  // This allows treeshaking and http to be loaded actually only when needed.

  const {
    http
  } = validators.validateHttp(settings.http); // Check if we encountered Errors and warns that we faced errors but will attempt to continue execution

  validators.checkValidationErrors(); // TODO: `ceid` is deprecated and will be removed in the future once BE's support PR
  // generation for Copy Experiments. This should be removed together with all `ceid` related logic

  if (ceid && ceid.length) {
    logDebug(DEBUG_MESSAGES.ceidDeprecationNotice, 'createClient');
  }

  const {
    resolveTreatments
  } = createTreatmentsResolver({
    asyncStore: getAsyncStore(store),
    apiDomain,
    ceid,
    http,
    onError,
    quickFetch,
    quickFetchLabel,
    treatments,
    experiments,
    identifiers,
    search,
    timeout,
    useCacheOnly,
    logDebug
  });
  const {
    logExposure,
    logExposures
  } = createExposureLogger({
    apiDomain,
    http,
    identifiers,
    resolveTreatments,
    onError,
    logDebug
  });
  return {
    logExposure,
    logExposures,
    resolve: resolveTreatments,
    debug
  };
}